
export default {
  props: {
    tags: {
      type: Array,
      default: () => []
    },
    highlight: {
      type: String,
      default: ''
    },
    maxVisible: {
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      show_rest: false
    }
  },
  computed: {
    sorted_tags(){
      const tags = this.tags.slice()
      if (this.highlight) return tags.sort((a) => this.checkTag(a) ? -1 : 1)
      return tags
    },
    highlight_tags() {
      if (this.highlight) return this.sorted_tags.filter(this.checkTag)
      return []
    },
    visible_tags() {
      const end = this.highlight_tags.length >= this.maxVisible ? 0 : this.highlight_tags.length + (this.maxVisible - this.highlight_tags.length)
      return this.sorted_tags.slice(this.highlight_tags.length, end)
    },
    hidden_tags(){
      return this.sorted_tags.slice(this.maxVisible)
    }
  },
  methods: {
    checkTag(tag){
      return tag.toLowerCase().includes(this.highlight.toLowerCase())
    }
  }
}
